import React from 'react';
import { Alert, Box, Button } from '@mui/material';

interface ApprovalErrorStateProps {
  notFound?: boolean;
  onRetry?: () => void;
}

const ApprovalErrorState: React.FC<ApprovalErrorStateProps> = ({ notFound, onRetry }) => (
  <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
    <Alert severity="error" action={onRetry ? <Button onClick={onRetry}>Retry</Button> : undefined}>
      {notFound
        ? 'This approval request was not found. It may have been completed or removed.'
        : 'Failed to load the approval request.'}
    </Alert>
  </Box>
);

export default ApprovalErrorState;
